import { initializeSdk } from 'utils/sdk.js';
import { removeOneTrustLink } from 'utils/helpers.js';
import { redirectForRegionLang } from 'utils/redirect.js';
import { preFetch, convertNodes } from 'Global/utils/helpers';
import { onScrollInit } from 'components/onScroll';
import { onHeroInit } from 'components/hero';
import { onGridsInit } from 'components/grid';
import { langSelectorInit } from 'components/lang-selector';
import AnalyticsManager from 'analytics/analyticsManager';
import { initAdobeAnalytics } from 'analytics/adobeAnalytics';
import { initAdobeLaunch } from 'analytics/adobeLaunch';
import { initAnimation } from 'Global/animation/index';
import { initCookiesBanner, removeFallbackBanner } from 'components/cookies-banner';
import { isDeviceSupported, isCrawlerBot } from 'basesiteScripts/checkDevice';
import smoothscroll from 'smoothscroll-polyfill';
import { addOneTrustOnConsentFunction, initalizeOneTrust, oneTrustIsActiveGroup, syncOneTrustConsent } from 'basesiteScripts/oneTrust';
import { deepGet } from 'bam-deep-get';
import { initButtonActions } from 'components/buttonActions';


if (!isDeviceSupported()) {
    window.location = '/unsupported';
} else if (!isCrawlerBot()) {
    redirectForRegionLang();
}

smoothscroll.polyfill();
preFetch();
convertNodes();
onScrollInit();
onHeroInit();
onGridsInit();
initAnimation();
langSelectorInit();
initButtonActions();
localStorage.removeItem('dss_super_bundle_selected');

initializeSdk(sdkPayload => {
    if (sdkPayload) {
        window.AnalyticsManager = window.AnalyticsManager || new AnalyticsManager(sdkPayload);
        initAdobeAnalytics();
        window.AnalyticsManager.fireGlimpseEvent('appLaunched');
        window.AnalyticsManager.firePageLoad();

        if (window.OneTrust) {

            if (window.dssMlpConfigs.adobeLaunchUrl) {
                addOneTrustOnConsentFunction(() => {
                    // eslint-disable-next-line new-cap
                    if (oneTrustIsActiveGroup('4')) {
                        // eslint-disable-next-line new-cap
                        window.Optanon.InsertScript(window.dssMlpConfigs.adobeLaunchUrl, 'head', () => {
                            initAdobeLaunch(false);
                        }, null, '4');
                    }
                });
            }

            const oneTrustTrack = () => {
                window.AnalyticsManager.fireAction('Content Update Success');
                window.AnalyticsManager.fireGlimpseEvent('consentGranted');

                const id = deepGet(sdkPayload, 'sessionInfo.account.id', null);
                const countryCode = deepGet(sdkPayload, 'sessionInfo.location.countryCode', '');

                syncOneTrustConsent(id || window.AnalyticsManager.userData.dssDeviceId, !!(id), countryCode);
            };

            initalizeOneTrust(oneTrustTrack, {
                onload: () => {
                    removeFallbackBanner();
                    const prefLink = document.querySelector('.onetrust-manage');
                    if (prefLink) {
                        prefLink.style.display = 'inline-block';
                    }
                },
                onerror: () => {
                    initCookiesBanner();
                    removeOneTrustLink();
                }
            });
        } else {
            initCookiesBanner();
            initAdobeLaunch(true);
            removeOneTrustLink();
        }
    }
});
